<div>
  <div class="payment-if-missing-subsection">
    <div
      class="payment-if-missing--subsection-headline"
      *ngIf="
        instanceName === 'payment' ||
        instanceName === 'payment-express' ||
        instanceName === 'payment-then-client-esign' ||
        instanceName === 'conversion-payment'
      "
    >
      COVERAGE
    </div>
    <div class="payment-if-missing--subsection-headline" *ngIf="tlicMode">TEMPORARY COVERAGE AMOUNT</div>
    <div class="payment-if-missing--premium-item">
      <div class="payment-if-missing--currency">{{ formattedActiveFace }}</div>
      <div class="payment-if-missing--explanation" *ngIf="tlicMode">Lasts up to 120 days.</div>
      <div class="payment-if-missing--explanation" *ngIf="faceOverTlicFace && tlicMode">
        Your application is for {{ totalFormattedFace }}. The maximum temporary coverage amount is
        {{ formattedTlicCap }}.
      </div>
      <div
        class="payment-if-missing--explanation"
        *ngIf="
          instanceName === 'payment' ||
          instanceName === 'payment-express' ||
          instanceName === 'payment-then-client-esign' ||
          instanceName === 'conversion-payment'
        "
      >
        {{ policyDescription }}
      </div>
    </div>
    <div *ngIf="isJointApp && !tlicMode" class="payment-if-missing--premium-item--secondary">
      <div class="payment-if-missing--currency">{{ secondaryFormattedFace }}</div>
      <div class="payment-if-missing--explanation">{{ secondaryPolicyDescription }}</div>
    </div>
  </div>
  <div class="payment-if-missing-subsection">
    <div class="payment-if-missing--subsection-headline" *ngIf="tlicMode">ONE-TIME PREMIUM</div>
    <div class="payment-if-missing--subsection-headline" *ngIf="!tlicMode">AMOUNT DUE</div>
    <div class="quote-page-product__field">
      <div id="prepare-quote-form__premium" class="quote-page-product__premium">
        <div class="payment-if-missing--currency" *ngIf="tlicMode">
          {{ formattedTlicAmount }}
        </div>
        <div
          class="payment-if-missing--currency"
          *ngIf="
            instanceName === 'payment' ||
            instanceName === 'payment-express' ||
            instanceName === 'payment-then-client-esign' ||
            instanceName === 'conversion-payment'
          "
        >
          {{ formattedPremiumAmount }}<span *ngIf="instanceName !== 'conversion-payment'">/{{ paymentTermAbbrv }}</span>
        </div>
      </div>
    </div>
    <div class="payment-if-missing--explanation" *ngIf="tlicMode">
      <ng-container *ngIf="is1035ToPremium; else no1035ToPremium">
        We’ll charge you when you sign your application, but this amount will be refunded either when you accept your
        final offer or if you don’t finish the process.
      </ng-container>
      <ng-template #no1035ToPremium>
        We'll charge you when you sign your application, but this amount will be credited to your policy's first premium
        (or refunded if you don't finish the process).
      </ng-template>
    </div>
    <div class="payment-if-missing--divider"></div>
    <div
      *ngIf="
        instanceName === 'payment-express' ||
        instanceName === 'payment' ||
        instanceName === 'payment-then-client-esign' ||
        instanceName === 'conversion-payment'
      "
    >
      <div class="payment-if-missing--explanation">
        {{ paymentTerm }} base premium
        <span class="payment-if-missing--explanationAmount">{{ basePremium | casCurrency }}</span>
      </div>
      <div class="payment-if-missing--explanation" *ngIf="hasRefund">
        <span>Refund</span>
        <basic-tooltip class="payment-if-missing--tooltip">
          <div label>
            <icon class="question-mark" type="question-mark"></icon>
          </div>
          <div tip>
            <p>
              You’re receiving a prorated refund for the pre-paid portion of the term life policy that you are
              converting. This is a one-time refund: it does not apply to future recurring premiums.
            </p>
          </div>
        </basic-tooltip>
        <span class="payment-if-missing--explanationAmount">{{ formattedRefundAmount }}</span>
      </div>
      <div *ngFor="let rider of policyRiders" class="payment-if-missing--explanation">
        {{ rider.description }} premium: {{ rider.premiumBase | casCurrency }}
      </div>
    </div>
  </div>
</div>
